import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Record } from 'immutable';
import _ from 'lodash';

import t from '../../../lib/I18n';

import CheckedMarketingOption from './CheckedMarketingOption';
import config from '../../../config';

export default function PrefsTable ({
    form,
    onChange,
    isOver16,
    enableEmailMarketing,
    enableSmsMarketing,
    hideAutoDrOption,
    isHalfOnState,
    isEmailProducts,
}) {
    const [updatedHalfOnState, setUpdatedIsHalfOnState] = useState(isHalfOnState);

    const isSouthEastern = config.get('brand') === 'southeastern';

    const _handleTogglePreference = (field, value) => {
        const preferences = form.set(field, value);
        const updatedPreferences = isSouthEastern
            ? preferences.set('emailProducts', preferences.emailPromotions )
            : preferences;

        if (field === 'emailPromotions' && isSouthEastern) {
            setUpdatedIsHalfOnState(false);
        }

        onChange('preferences', updatedPreferences);
    };

    const defaultProps = {
        enableEmailMarketing,
        enableSmsMarketing
    };

    const defaultMarketingProps = Object.assign({}, defaultProps, {
        onChange: _handleTogglePreference,
        form
    });

    return (
        <fieldset className="hidden-fieldset margin-bottom">
            { enableEmailMarketing && (
                <legend className="checked-option__row checked-option__header">
                    { t('account.details.emailMarketing') }
                </legend>
            ) }
            { enableSmsMarketing && (
                <legend className="checked-option__row checked-option__header">
                    { t('account.details.smsMarketing') }
                </legend>
            ) }

            <ul className="margin-bottom--0">
                <CheckedMarketingOption { ...defaultMarketingProps }
                    flag="enableServicePreference"
                    helpIconFeatureFlag="enableServicePreferenceHelpIcon"
                    emailField="emailServiceUpdates"
                    smsField="smsServiceUpdates"
                    text={ t('preference-centre.service-updates') }
                    helpModalText={ t('preference-centre.service-updates.help') }
                    emailTestId="marketing-prefs-email-service-updates-checkbox"
                    smsTestId="marketing-prefs-sms-service-updates-checkbox"
                />

                <CheckedMarketingOption { ...defaultMarketingProps }
                    flag="enablePromotionsPreference"
                    helpIconFeatureFlag="enablePromotionsPreferenceHelpIcon"
                    emailField="emailPromotions"
                    smsField="smsPromotions"
                    text={ t('preference-centre.promotions') }
                    disabled={ !isOver16 }
                    helpModalText={ t('preference-centre.promotions.help') }
                    isHalfOnState={ updatedHalfOnState && isSouthEastern }
                    isEmailProducts={ isEmailProducts }
                    southeasternId={ isSouthEastern && "emailPromotionsAndProducts" }
                    emailTestId="marketing-prefs-email-promotions-checkbox"
                    smsTestId="marketing-prefs-sms-promotions-checkbox"
                />

                <CheckedMarketingOption { ...defaultMarketingProps }
                    flag="enableProductsPreference"
                    emailField="emailProducts"
                    smsField="smsProducts"
                    text={ t('preference-centre.products') }
                    disabled={ !isOver16 }
                    helpModalText={ t('preference-centre.products.help') }
                    emailTestId="marketing-prefs-email-products-checkbox"
                    smsTestId="marketing-prefs-sms-products-checkbox"
                />

                { !hideAutoDrOption && (
                    <CheckedMarketingOption { ...defaultMarketingProps }
                        flag="enableAutoDelayRepay"
                        emailField="autoDelayRepay"
                        hideSmsField
                        text={ t('account.register.autoDelayRepay') }
                        helpModalText='account.register.autoDelayRepay.description'
                        emailTestId="marketing-prefs-email-auto-delay-repay-checkbox"
                    />
                ) }
            </ul>
        </fieldset>
    );
}

PrefsTable.propTypes = {
    form: PropTypes.instanceOf(Record).isRequired,
    onChange: PropTypes.func,
    isOver16: PropTypes.bool,
    enableEmailMarketing: PropTypes.bool,
    enableSmsMarketing: PropTypes.bool,
    hideAutoDrOption: PropTypes.bool,
    isHalfOnState: PropTypes.bool,
    isEmailProducts: PropTypes.bool,
};

PrefsTable.defaultProps = {
    onChange: _.noop,
    isOver16: false,
    enableEmailMarketing: true,
    enableSmsMarketing: true,
    hideAutoDrOption: false
};
